var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.022,
    height: 24.864,
    viewBox: "0 0 26.022 24.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.511 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.964,20.852a.732.732,0,0,0-.591-.5l-7.75-1.126L13.157,12.2a.732.732,0,0,0-1.314,0L8.377,19.227.627,20.353A.732.732,0,0,0,.221,21.6l5.608,5.466L4.506,34.788a.732.732,0,0,0,1.063.772L12.5,31.915l6.932,3.644a.732.732,0,0,0,1.063-.772L19.17,27.069,24.779,21.6A.732.732,0,0,0,24.964,20.852Z",
    transform: "translate(0 -11.796)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar01);
export default __webpack_public_path__ + "static/media/Icon-Star-01.c4fcda4c46fd35612e8d8d759b8710dd.svg";
export { ForwardRef as ReactComponent };